import { render, staticRenderFns } from "./BoardTree.vue?vue&type=template&id=f912b220&scoped=true&"
import script from "./BoardTree.vue?vue&type=script&lang=js&"
export * from "./BoardTree.vue?vue&type=script&lang=js&"
import style0 from "./BoardTree.vue?vue&type=style&index=0&id=f912b220&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f912b220",
  null
  
)

export default component.exports